import { authRoles } from 'app/auth/authRoles';
import Loadable from 'app/components/Loadable';
import { lazy } from 'react';

const ChargrPrsAnalytics = Loadable(lazy(() => import('./ChargrPrsAnalytics')));

const chargerProsRoutes = [
  { path: '/chgrpros/default', element: <ChargrPrsAnalytics />, auth: authRoles.admin },
];

export default chargerProsRoutes;
